import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

const PaymentMethods = (props) => {
  const { agencyFormPayload } = props || {}
  const {
    entityState: {
      bank_account_bsb,
      bank_account_name,
      bank_account_number,
    },
    handlers,
  } = agencyFormPayload

  return (
    <DashboardModule title="Payment Methods">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Bank Account Number">
            <input
              name="bank_account_number"
              value={bank_account_number}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Bank Account BSB" marginTop={['large', 0]}>
            <input
              name="bank_account_bsb"
              value={bank_account_bsb}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Field label="Bank Account Name" marginTop="large">
          <input
            name="bank_account_name"
            value={bank_account_name}
            type="text"
            {...handlers}
          />
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

PaymentMethods.propTypes = {
  agencyFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      bank_account_bsb: PropTypes.string.isRequired,
      bank_account_name: PropTypes.string.isRequired,
      bank_account_number: PropTypes.string.isRequired,
    }),
    handlers: PropTypes.object.isRequired,
  }).isRequired,
}

export default PaymentMethods
